/* PSI cart drawer "Complete your party" one-tap Add (24 Oct 2026).
   Adds the product with the same personalisation (Name, Event Date...) as the cart item of that theme,
   then re-renders the drawer the same way the theme's own <add-to-cart> does. */
(function () {
  if (window.__psiRc) return; window.__psiRc = 1;
  /* open the drawer at the top so the customer's own items come first (the list is column-reverse) */
  function toTop() {
    var m = document.getElementById('main-cart-items');
    if (!m) return;
    var sb = m.style.scrollBehavior; m.style.scrollBehavior = 'auto';
    m.scrollTop = -m.scrollHeight; m.style.scrollBehavior = sb;
  }
  var det = document.querySelector('cart-drawer details');
  if (det && window.MutationObserver) new MutationObserver(function () { if (det.hasAttribute('open')) setTimeout(toTop, 60); }).observe(det, { attributes: true, attributeFilter: ['open'] });
  /* Cart-drawer X sends the customer back to a collection (assets/global.js reads sessionStorage 'lastCollectionUrl').
     Order: theme of the product page they are on -> the collection page they are on -> newest theme item in the cart. */
  function syncReturn() {
    var el = document.querySelector('#mini-cart [data-psi-return]');
    var u = el && el.getAttribute('data-psi-return');
    /* the theme they are looking at right now wins: a theme product page, or the collection page they are on */
    if (window.psiPageTheme) u = window.psiPageTheme;
    else if (/^\/collections\/[^\/]+\/?$/.test(location.pathname)) u = location.pathname;
    if (u && u.charAt(0) === '/') { try { sessionStorage.setItem('lastCollectionUrl', u); } catch (_) {} }
  }
  var mcs = document.getElementById('mini-cart'), loaded = !!document.getElementById('main-cart-items');
  syncReturn();
  if (mcs && window.MutationObserver) new MutationObserver(function () {
    syncReturn();
    if (!loaded && document.getElementById('main-cart-items')) { loaded = true; setTimeout(toTop, 60); }
  }).observe(mcs, { childList: true });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-psi-rc-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var wrap = b.closest('[data-psi-rc]'), props = {};
    try {
      var all = JSON.parse((wrap && wrap.getAttribute('data-psi-rc-props')) || '{}') || {};
      var pairs = Array.isArray(all) ? all : Object.keys(all).map(function (k) { return [k, all[k]]; });
      pairs.forEach(function (pr) {
        var k = pr && pr[0], v = pr && pr[1];
        if (k && String(k).charAt(0) !== '_' && v !== null && v !== '' && typeof v !== 'object') props[k] = v;
      });
    } catch (_) {}
    var mc = document.querySelector('mini-cart');
    var sections = mc && mc.getSectionsToRender ? mc.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var item = { id: Number(b.getAttribute('data-variant-id')), quantity: 1 };
    if (Object.keys(props).length) item.properties = props;
    b.disabled = true; b.classList.add('loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (s && s.status && s.status >= 400) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: s.description || s.message } }));
          return;
        }
        if (mc && mc.renderContents && s && s.sections) { mc.renderContents(s); setTimeout(toTop, 60); }
        else window.location.href = root + 'cart';
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: s } }));
      })
      .catch(function (err) { console.error(err); })
      .finally(function () { b.disabled = false; b.classList.remove('loading'); });
  });
})();
